import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'alertbox',
    templateUrl: './alertbox.component.html'
})

export class AlertBoxComponent implements OnInit {

    @Input() public alerts: Array<string> = [];
    @Input() public messageBox: string;
    @Input() public delay: number;
    @Input() public typeException: number;
    @Input() public messageComplet: string;
    public static changeMensaje: Subject<number> = new Subject();
    public showSpinner: Boolean = false;

    constructor(public router: Router) {
        AlertBoxComponent.changeMensaje.subscribe(res => {
            this.MostrarError(res);
         });
    }

    public ngOnInit() {
    }

    public closeAlert(i: number): void {
        this.alerts.splice(i, 1);
    }

    public closeAlertBox(): void {
        setTimeout(() => {
            this.alerts.splice(0, 1);
        }, this.delay);
    }

    public CerrarVentana(): void {
        this.typeException = -1;
    }

    public MostrarError(valor: number) {
        this.typeException = valor;
    }

    public startSpinner(): void {
        //  this.showSpinner = true;
    }

    public Navegar(ruta: string) {
        this.router.navigate([ruta]);
    }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/alertbox.component.ts